"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparePanel = void 0;
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var grouping_1 = require("../../grouping");
var underscore_1 = __importDefault(require("underscore"));
var Backbone = __importStar(require("backbone"));
var util_1 = require("../../utils/util");
// @ts-ignore - just remove?
var ComparePanel = /** @class */ (function (_super) {
    __extends(ComparePanel, _super);
    function ComparePanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparePanel.prototype.events = function () {
        return {
            'change select': 'updateComparison',
            'click .js-clear-selection': 'clearComparison',
            'change .js-comparison-group': 'onGroupSelection'
        };
    };
    ComparePanel.prototype.initialize = function (options) {
        console.log(options);
        // @ts-ignore
        this.municipality = options.municipality;
        this.model.bind('change:municipalities', this.redrawSelectedOptions, this);
    };
    ComparePanel.prototype.updateComparison = function () {
        var selected = util_1.toStringArray($('form.compare_munis select').val());
        return this.updateSelectedMunicipalities(selected);
    };
    ComparePanel.prototype.clearComparison = function () {
        this.updateSelectedMunicipalities([]);
        return this.redrawSelectedOptions();
    };
    ComparePanel.prototype.onGroupSelection = function (e) {
        var _this = this;
        var grouping = e.target.value.split('.')[0];
        if (!this.municipality) {
            console.log("Unknown municipality: " + this.municipality);
            return;
        }
        var visible = (function () {
            switch (grouping) {
                case 'all': return underscore_1.default.flatten(underscore_1.default.values(grouping_1.Grouping.groups.comparable));
                case 'comparable': return grouping_1.Grouping.forMunicipality(_this.municipality, 'comparable');
                case 'county': return grouping_1.Grouping.forMunicipality(_this.municipality, 'county');
                default: throw new Error("Unknown grouping: " + grouping);
            }
        })();
        visible = underscore_1.default.reject(visible, function (name) { return name === _this.municipality; });
        visible.sort();
        var select = this.$el.find('select');
        select.find('option').remove();
        for (var _i = 0, visible_1 = visible; _i < visible_1.length; _i++) {
            var municipality = visible_1[_i];
            select.append($('<option>', { value: municipality }).html(municipality));
        }
        this.updateSelectedMunicipalities(underscore_1.default.intersection(visible, this.model.get('municipalities')));
        return this.redrawSelectedOptions();
    };
    ComparePanel.prototype.redrawSelectedOptions = function () {
        var selected = this.model.get('municipalities').slice().sort();
        return this.$('select').val(selected);
    };
    ComparePanel.prototype.updateSelectedMunicipalities = function (municipalities) {
        if (!this.municipality) {
            console.log("Unknown municipality: " + this.municipality);
            return;
        }
        municipalities = [this.municipality].concat(municipalities);
        this.model.set({ municipalities: municipalities });
        return this.setCookie(JSON.stringify(municipalities), 1);
    };
    ComparePanel.prototype.setCookie = function (value, days) {
        // days from now
        var date = new Date(Date.now() + days * 86400e3).toUTCString();
        return document.cookie = "municipalities=" + value + "; path=/; expires=" + date;
    };
    return ComparePanel;
}(Backbone.View));
exports.ComparePanel = ComparePanel;
